export const REPORTS_ROUTE = 'betting-reports';
export const REPORTS_PATH = `/${REPORTS_ROUTE}`;
export const PAYMENTS_REPORTS_ROUTE = 'payments';
export const PAYMENTS_REPORTS_PATH = `${REPORTS_PATH}/${PAYMENTS_REPORTS_ROUTE}`;
